import { Component, AfterViewInit, OnInit, ChangeDetectorRef, ElementRef, ViewChild, Renderer } from '@angular/core';

import {Title } from '@angular/platform-browser';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { StorageService } from '../services/storage.service';
import { RestService } from '../services/rest.service';

import 'rxjs/add/operator/toPromise';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'manifest',
  providers: [StorageService, RestService],
  templateUrl: './manifest.component.html',
  styleUrls: ['./manifest.component.scss']
})
export class ManifestComponent implements AfterViewInit, OnInit {

  scannedValue: string = null;

  manifestStorages: any[] = [];
  manifestContainers: any[] = [];
  containers2scan: any[] = [];
  storages: any[] = [];
  private storage: any = null;
  status: string = null;

  private container: any = null;
  manifestType: string = null;

  filterTitle: string;
  linehaul_name: string =  null;
  loading: boolean = false;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _restService: RestService,
    private _snackBarService: MdSnackBar,
    private _router: Router,
    private _route: ActivatedRoute,
    private _dialogService: TdDialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService,
    public renderer: Renderer) {
  }

  @ViewChild('ft01') infocus: ElementRef;

  ngOnInit(): void {
    this._titleService.setTitle('Manifest');
    this._route.url.subscribe((url: any) => {
      this.manifestType = (url.length > 1 ? url[1].path : '');
    });
    this.load();
  }


  ngAfterViewInit(): void {
    // broadcast to all listener observables when loading the page
    this.media.broadcast();
    // force a new change detection cycle since change detections
    // have finished when `ngAfterViewInit` is executed
    this._changeDetectorRef.detectChanges();
  }

  async loadValue(value: string): Promise<void> {
    try {
        if (value == null || value == '')  {
          // do nothing
        } else {
          // is it a parcel or a container?
          try {
              this.container = await this._storageService.getContainer(value).toPromise();
          } catch (error) {
              // it could be a parcel
              this.container = null;
          }
          if (!this.container) {
              // if parcel => get parcel and validate status
              if (this.manifestType == 'exportCH') {
                this.storages = await this._storageService.getParcel(value).toPromise(); // could we also search here by trackingNumber?
              } else if (this.manifestType == 'exportDE' || this.manifestType == 'importDE') {
                this.storages = await this._storageService.getParcelByTrackingNumber(value).toPromise();
              }
              for (let element of this.storages) {
                if ((this.manifestType == 'exportCH' && element.workflowStatus != 'ECOMM_COMPLETE') ||
                    (this.manifestType == 'exportDE' && element.workflowStatus != 'TAXATION') ||
                    (this.manifestType == 'importDE' && element.workflowStatus != 'TAXATION')) {
                    this._dialogService.openAlert({ message: 'Parcel '+ value + ' in wrong status!' });
                    this.storage = null;
                    break;
                } else {
                    this.storage = element;
                    break;
                }
              }
              if (this.storage) { // add parcel to manifest list
                this.manifestStorages.push(this.storage);
              }
              if (this.manifestStorages.length > 0) {
                this.manifestStorages.reverse(); // to show last added element on top of the list
              }
          } else {
              this.storage = null;
              if (this.container.containerStatus == 'CLOSED') {

                // for ExportDE manifest: remove from list availableContainers
                // check if parcel is in the list
                let found: boolean = false;
                if (this.manifestType == 'exportDE') {
                  for (let i = this.containers2scan.length - 1; i >= 0; i--) {
                    if (this.containers2scan[i].name == this.container.name) {
                        this.containers2scan.splice(i, 1);
                        found = true;
                        break;
                    }
                  }
                }

                if (!found && this.manifestType == 'exportDE') {
                  this._dialogService.openAlert({ message: 'Container not available!: ' + this.container.name });
                } else {
                  // validate that container.lineHaul.workflow matches the manifestType
                  let addInfoItem: any = this.container.addInfo.find(element => element.keyValue == 'line_haul');
                    if (this.linehaul_name == null){
                        this.linehaul_name = addInfoItem.textValue.substring(0, 3);
                    } else{
                        if (this.linehaul_name != addInfoItem.textValue.substring(0, 3)){
                            this._dialogService.openAlert({ message: 'Container with diferent linehaul!'});
                            return;
                        }
                    }
                  // get lineHaul by name
                  let lineHaul = await this._storageService.getLineHaulByNameAndWorkflow(addInfoItem.textValue, this.manifestType).toPromise();
                  if (lineHaul) {
                    // if container => get all parcels in container (already validated when stored to container)
                    this.storages = await this._storageService.getContainerNameParcels(value).toPromise();
                    for (let element of this.storages) { // add parcels to manifest list
                      this.manifestStorages.push(element); 
                    }
                    if (this.manifestStorages.length > 0) {
                      this.manifestStorages.reverse(); // to show last added element on top of the list
                    }
                    // keep added containers to set status SHIPPED after creating the manifest
                    this.manifestContainers.push(this.container);

                  } else {
                    this._dialogService.openAlert({ message: 'Line haul is not found'});
                  }
                }
              } else {
                this._dialogService.openAlert({ message: 'Container in wrong status!: ' + this.container.containerStatus });
              }
          }
          // clear scannedValue
          this.scannedValue = null;
        }
        } catch (error) {
          this._dialogService.openAlert({ message: 'Container/parcel '+ value + ' does not exist!' });
          this.storage = null;
          this.scannedValue = null;
        } finally {
        }
  }

  isParcel() {
    if (this.storage) {
      return true;
    } else {
      return false;
    }
  }

  isContainer() {
    if (this.container) {
      return true;
    } else {
      return false;
    }
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('manifestStorages.list');
      if (this.manifestType == 'exportDE') { // manifestType is not yet set here!!!
        this._loadingService.register('availableContainers.list');
        this.loadContainers2scan();
      }
    } catch (error) {

    } finally {
      if (this.manifestType == 'exportDE') {
        this._loadingService.resolve('availableContainers.list');
      }
      this._loadingService.resolve('manifestStorages.list');
    }
  }

  async loadContainers2scan (): Promise<void> {
    this.containers2scan = await this._storageService.getContainers('CONTAINER').toPromise();
    // filter closed containers
    this.containers2scan = this.containers2scan.filter((container: any) => {
      return (container.containerStatus.indexOf('CLOSED') != -1);
    });
  }

  getStatus() {
    return this.status;
  }

  keytab(event, innerText: string){
    if (innerText == 'Scan value') {
      this.loadValue(this.scannedValue);
    }

    let path = event.composedPath();
    let element = path[5]; // naviagte to md-card-content

    let child;

      for (let j = 0; j < element.children.length; j++) {
        if (element.children[j].innerText == innerText) { // navigate to md-input-container with the given text
          child = element.children[j].children[0].children[0].children[0].children[0]; // navigate to input area where value is entered
        }
      }

    if(child == null)  // check if its null
        return;
    else
      child.focus();   // focus if not null
        return;
  }

  goBack(): void {
    this.linehaul_name = null;
    this.clearForm();
    this._router.navigate(['/manifestchoice/manifest/'+this.manifestType]);
  }

  clearForm() {
    this.storage = null;
    this.status = null;
    this.manifestStorages = [];
    this.manifestContainers = [];
    this.scannedValue = null;
    this.container =  null;
    this.loadContainers2scan();
  }

  /*
  removeStorage(storage:any) {
    for (let i = this.manifestStorages.length - 1; i >= 0; i--) {
      if (this.manifestStorages[i].reference == storage.reference) {
        this.manifestStorages.splice(i, 1);
        break;
      }
    }
  }
*/

createManifest(): void {
  this._dialogService
    .openConfirm({ message: 'Are you sure you want to transmit this manifest?' })
    .afterClosed().toPromise().then((confirm: boolean) => {
      if (confirm) {
        this.loading = true;
        this._createManifest()
          .then(() => {
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    });
}

  private async _createManifest(): Promise<void> {
    try {
      this._loadingService.register('manifestStorages.list');
        const nameDate = new Date();
      
        const Month = nameDate.getMonth() + 1; // check if this is correct!!
        let MonthString : string = "";
        if (Month < 10) {MonthString = "0" + Month.toString()}
        else {MonthString = Month.toString()}
    
        let DayString : string = "";
        if (nameDate.getDate() < 10) {DayString = "0" + nameDate.getDate().toString()}
        else {DayString = nameDate.getDate().toString()}
    
        let manifestNumberString : string = "";
        let isEcomm : boolean = false;
        const date = DayString + MonthString + nameDate.getFullYear().toString();
        const time = nameDate.getHours().toString() + nameDate.getMinutes().toString() + nameDate.getSeconds().toString() + nameDate.getMilliseconds().toString();
        if (this.manifestType == 'exportDE') {
          manifestNumberString =  date + "_ExportDE_" + time;
        } else if (this.manifestType == 'exportCH') {
          let addInfo: any[] = this.container.addInfo;   // use last loaded container      
          for(let element of addInfo) {
            if (element.keyValue.toLowerCase().indexOf('line_haul') > -1) {

              let lineHaul = await this._storageService.getLineHaulByNameAndWorkflow(element.textValue, this.manifestType).toPromise();

              if (!lineHaul.serviceType) { // no service type defined for the lineHaul
                manifestNumberString = date + "_ManifestEcomm_" + time;
                isEcomm = true;
              } else {
                manifestNumberString = date + "_ManifestExport_" + time;
                isEcomm = false;
              }
              break;
            }
          }          
        } else if (this.manifestType == 'importDE') {
          manifestNumberString = date + "_ImportDE_" + time;
          isEcomm = false;
        }
        
        let manifest = {
          manifestNumber: manifestNumberString,
          manifestDate: nameDate,
          transportMode: null,
          accompanyingDocument: null,
          accompanyingDocumentNumber: null,
          injectionPoint: null,
          eta: null,
          orders: []
        }
        
        for (let element of this.manifestStorages) { // add parcels to manifest list
          if (this.manifestType == 'exportCH') {
            manifest.orders.push({hawb: element.reference, projectId: element.projectId})
          } else {
            manifest.orders.push({hawb: element.reference, projectId: element.projectId, businessKey: element.businessKey})
          }
        }
  
        console.log("LOG manifest", JSON.stringify(manifest));
  
        // Send manifest to rest-service
        if (this.manifestType == 'exportDE') { // create import manifest wih type exportDE and mandant mcgExportDE
          await this._restService.createExportDEManifest(manifest, manifestNumberString).toPromise();
          // misusse of create storage to update warehouse_item state without existing order in app
          for (let element of this.manifestStorages) { 
            let storage = {
              itemCount: 1,
              containerName: null, // TAKE_OUT_WAREHOUSE
              reference: element.reference,
              workflowStatus: 'READY_TO_SHIP',
              storeUser: null,
              storeDate: new Date(),
              businessKey: element.businessKey,
              projectId: element.projectId
            }
            let res = await this._storageService.createStorage(storage).toPromise();
          }
        } else if (this.manifestType == 'exportCH') {// create export/return manifest
          await this._restService.createExportCHManifest(manifest, isEcomm, null, manifestNumberString).toPromise();
        } else if (this.manifestType == 'importDE') {
          await this._restService.createExportCHManifest(manifest, isEcomm, 'DE', manifestNumberString).toPromise();
          // misusse of create storage to update warehouse_item state without existing order in app
          for (let element of this.manifestStorages) { 
            let storage = {
              itemCount: 1,
              containerName: null, // TAKE_OUT_WAREHOUSE
              reference: element.reference,
              workflowStatus: 'READY_TO_SHIP',
              storeUser: null,
              storeDate: new Date(),
              businessKey: element.businessKey,
              projectId: element.projectId
            }
            let res = await this._storageService.createStorage(storage).toPromise();
          }
        }

        // set containers to status SHIPPED
        for (let j = this.manifestContainers.length -1; j >= 0; j--) {
          let container = this.manifestContainers[j];
          container.containerStatus = 'SHIPPED';
          await this._storageService.updateContainer(container, true).toPromise();
        }

        this.storage = null;
        this.manifestStorages = [];
        this.manifestContainers = [];
                
        this._snackBarService.open('Manifest created:' + manifestNumberString, 'Ok');
      } catch (error) {
        this._dialogService.openAlert({message: 'There was an error transmitting the manifest! ' + error.message});
        if (error.message.startsWith("MANIFEST OK. The manifest") && error.message.endsWith("will be generated soon!")) {
          // set containers to status SHIPPED
          for (let j = this.manifestContainers.length -1; j >= 0; j--) {
            let container = this.manifestContainers[j];
            container.containerStatus = 'SHIPPED';
            this._storageService.updateContainer(container, true).toPromise();
          }
        }
      } finally {
        this._loadingService.resolve('manifestStorages.list');
      }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/manifest/manifest.component.ts